import { useQuery } from '@apollo/client';

import GetLastIndicatedUnsureOfRolesAndSkills from 'bundles/onboarding-common/queries/GetLastIndicatedUnsureOfRolesAndSkills.graphql';
import type {
  GetLastIndicatedUnsureOfRolesAndSkillsQuery,
  GetLastIndicatedUnsureOfRolesAndSkillsQueryVariables,
} from 'bundles/onboarding-common/queries/__generated__/GetLastIndicatedUnsureOfRolesAndSkills';

const useHasIndicatedUnsureOfRoleOrSkills = ({ skip = false }: { skip?: boolean } = {}) => {
  const { data, loading } = useQuery<
    GetLastIndicatedUnsureOfRolesAndSkillsQuery,
    GetLastIndicatedUnsureOfRolesAndSkillsQueryVariables
  >(GetLastIndicatedUnsureOfRolesAndSkills, {
    context: { clientName: 'gatewayGql' },
    errorPolicy: 'all',
    fetchPolicy: 'network-only',
    skip,
  });

  return {
    hasIndicatedUnsureOfRole: !!data?.LearnerProfile?.me?.lastIndicatedUnsureRolesAt,
    hasIndicatedUnsureOfSkill: !!data?.LearnerProfile?.me?.lastIndicatedUnsureSkillsAt,
    loading,
  };
};

export default useHasIndicatedUnsureOfRoleOrSkills;
